<template>
  <div id="digitalization-project-settings">
    <digitalization-project-content-types
      :digitalization-project-id="digitalizationProjectId"
    ></digitalization-project-content-types>

    <check-bot-configs-management :project-id="digitalizationProjectId" />
  </div>
</template>

<script src="./DigitalizationProjectSettings.script.ts" lang="ts"></script>
<style
  src="./DigitalizationProjectSettings.style.scss"
  lang="scss"
  scoped
></style>
